(() => {
  const start = async () => {
    const root = document.querySelector('.recently_viewed_proudct');
    const current = root?.dataset.productHandle;
    const grid = root?.querySelector('[grid-recentViewProduct]');
    if (!current || !grid) return;
    let history = [];
    try {
      history = (localStorage.getItem('shopify-recent-view') || '').split(',').filter(Boolean);
      history = [...new Set(history.filter(handle => handle !== current))].slice(-8);
      localStorage.setItem('shopify-recent-view', [...history, current].join(','));
    } catch (_) {}
    const cards = await Promise.all(history.reverse().map(async handle => {
      try {
        const response = await fetch('/products/' + encodeURIComponent(handle) + '?view=card');
        return response.ok ? await response.text() : '';
      } catch (_) { return ''; }
    }));
    grid.innerHTML = cards.join('');
    if (grid.querySelector('.product__card')) {
      root.classList.remove('no-js-inline');
      root.querySelector('.swiper')?.swiper?.update();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
